<template>
    <div>
        <div class="row">
            <div class="col-6">
                <span v-if="!double.left.length">Choose element</span>
                <div class="mt-2">
                    <div v-for="(item, index) in double.left" :key="index">
                        <button
                            class="btn btn-danger waves-effect waves-light mr-1"
                            type="button"
                            @click="deleteElement(index, 'left')"
                        >
                            <i class="far fa-trash-alt" />
                        </button>
                        <component
                            :is="`section-double-${item.key}`"
                            v-model="item.value"
                            @input="$emit('input', double)"
                        />
                    </div>
                </div>
                <div
                    v-if="!double.left.length"
                    class="col-12 d-flex flex-wrap justify-content-around mb-3"
                >
                    <button
                        v-for="component in components"
                        :key="component"
                        class="btn btn-success waves-effect waves-light mr-1 mt-1 btn-sm"
                        @click="addContent(component, 'left')"
                    >
                        <i class="fas fa-plus-circle" />
                        {{ formatText(component) }}
                    </button>
                </div>
            </div>
            <div class="col-6">
                <span v-if="!double.right.length">Choose element</span>
                <div class="mt-2">
                    <div v-for="(item, index) in double.right" :key="index">
                        <button
                            class="btn btn-danger waves-effect waves-light mr-1"
                            type="button"
                            @click="deleteElement(index, 'right')"
                        >
                            <i class="far fa-trash-alt" />
                        </button>
                        <component
                            :is="`section-double-${item.key}`"
                            v-model="item.value"
                            @input="$emit('input', double)"
                        />
                    </div>
                </div>
                <div
                    v-if="!double.right.length"
                    class="col-12 d-flex flex-wrap justify-content-around mb-3"
                >
                    <button
                        v-for="component in components"
                        :key="component"
                        size="sm"
                        class="btn btn-success waves-effect waves-light mr-1 mt-1 btn-sm"
                        @click="addContent(component, 'right')"
                    >
                        <i class="fas fa-plus-circle" />
                        {{ formatText(component) }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { startCase } from 'lodash';
import Text from './Text';
import Image from './Image';
import Video from './Video';
import Gallery from './Gallery';

export default {
    components: {
        'section-double-text': Text,
        'section-double-image': Image,
        'section-double-video': Video,
        'section-double-gallery': Gallery
    },

    props: {
        value: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            double: {
                left: [],
                right: []
            },
            components: ['text', 'image', 'video', 'gallery']
        };
    },

    mounted() {
        this.double = { ...this.value };
    },

    methods: {
        addContent(type, side) {
            let value = {};

            if (type === 'gallery') {
                value = [];
            } else if (type === 'text') {
                value = '';
            } else if (type === 'video') {
                value.linkOnly = true;
            }

            const newItem = {
                key: type,
                value
            };

            this.double = { ...this.double, [side]: [{ ...newItem }] };

            this.$emit('input', this.double);
        },

        deleteElement(index, side) {
            this.double[side].splice(index, 1);

            this.$emit('input', [...this.double]);
        },

        formatText(value) {
            return startCase(value);
        }
    }
};
</script>
